// Caitlyn — Piltover Peacemaker: fires a high-velocity shot at the primary target.

import { physicalDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const caitlynPeacemaker: Ability = {
  id: "caitlynPeacemaker",
  displayName: "Piltover Peacemaker",
  description: "Fires a high-velocity shot dealing 2.5× AD + 60 physical damage.",
  iconId: "CaitlynQ",

  targetShape({ target }) {
    return [target.pos];
  },

  computeHits({ caster, target }): AbilityHit[] {
    const stats = effectiveStats(caster);
    return [{ target, amount: physicalDamage(stats.ad * 2.5 + 60), type: "physical" }];
  },
};
